module.exports = __webpack_public_path__ + "img/CV.Drainage.Manhole.PE_chambers,_Type_3_inspection_chamber.ecb32124.png";